import { useRef, useState, useEffect } from "react";
// import PlayBtn from "../../../assets/icons/play_btn.svg?react";
import { ReactComponent as MuteBtn } from "../../../../assets/icons/Service Request Flow/mute_btn.svg";
import { ReactComponent as PauseBtn } from "../../../../assets/icons/Service Request Flow/pause_btn.svg";
// import PauseBtn from "../../../assets/icons/pause_btn.svg?react";
// import SoundBtn from "../../../assets/icons/sound_btn.svg?react";
import "./AudioPlayer.css";
import { useGlobalContext } from "../../../../context/GlobalContext";
import { getIcon } from "utils/iconsConfig";

const AudioPlayer = ({ src, id, onLoadedData,customStyle={} }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [hasAudio, setHasAudio] = useState(false);

  const { currentAudioId, setCurrentAudioId } = useGlobalContext();

  const isCurrent = currentAudioId === id;
  
  useEffect(() => {
    if (!src) {
      setHasAudio(false);
    } else {
      setHasAudio(true);
    }
  }, [src]);

  // Pause if another audio starts playing
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (currentAudioId && !isCurrent && isPlaying) {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
      setProgress(0);
    }
  }, [currentAudioId, isCurrent, isPlaying]);

  const togglePlay = async () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
      setCurrentAudioId(null);
      return;
    }

    try {
      setIsPlaying(true);
      setCurrentAudioId(id);
      await audio.play();
    } catch (err) {
      setIsPlaying(false);
      console.warn("Play failed:", err);
    }
  };
  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.muted = !isMuted;
    setIsMuted((prev) => !prev);
  };

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
    if (!audio || !audio.duration) return;
    setProgress((audio.currentTime / audio.duration) * 100);
  };

  const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio || !audio.duration) return;

    const newTime = (e.target.value / 100) * audio.duration;
    audio.currentTime = newTime;
    setProgress(e.target.value);
  };

  const formatTime = (time) => {
    if (!time || isNaN(time)) {
      return "00:00";
    }
    const mins = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${mins}:${secs}`;
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleLoadedMetadata = () => {
      if (isFinite(audio.duration)) {
        setDuration(audio.duration);
      } else {
        setDuration(0);
      }
    };

    audio.addEventListener("loadedmetadata", handleLoadedMetadata);

    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, [src]);

  return (
    <div className="audio-player" style={{...customStyle}}>
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => {
          const audio = audioRef.current;
          if (audio) {
            audio.currentTime = 0;
          }
          setIsPlaying(false);
          setProgress(0);
          setCurrentAudioId(null);
        }}
        onLoadedData={onLoadedData}
      />
      <button
        className="circle-btn"
        onClick={hasAudio ? togglePlay : undefined}
        disabled={!hasAudio}
        style={{
          paddingLeft: isPlaying ? "0px" : "4px",
          cursor: hasAudio ? "pointer" : "not-allowed",
          opacity: hasAudio ? 1 : 0.5,
        }}
      >
        {isPlaying ? <PauseBtn /> : getIcon("PlayIcon")}
      </button>
      <span className="time">{formatTime((progress / 100) * duration)}</span>
      <input
        type="range"
        min="0"
        max="100"
        value={progress}
        onChange={handleSeek}
        className="progress-bar"
        style={{
          background: `linear-gradient(to right, #8B8B8B 0%, #8B8B8B ${progress}%, #101010 ${progress}%, #101010 100%)`,
        }}
      />
      <span className="time">{formatTime(duration)}</span>
      <button className="mute-btn" onClick={toggleMute}>
        {/* {isMuted ? <MuteBtn /> : <SoundBtn />} */}
        {isMuted ? (
          <div style={{height:"25px",width:"25px",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <MuteBtn />
          </div>
        ) : (
          getIcon("VolumnIcon")
        )}
      </button>
    </div>
  );
};

export default AudioPlayer;
